import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { monthEndInventory: { getMonthEndInventory, } } = apiUrls;

export const MONTH_END_INVENTORY_SUCCESS = 'MONTH_END_INVENTORY_SUCCESS';
export const MONTH_END_INVENTORY_LOADING = 'MONTH_END_INVENTORY_LOADING';


export const getMonthEndInventoryData = ({ date }) => async (dispatch) => {
        try {
            const { url } = getMonthEndInventory
            const requestData = {
                ...getMonthEndInventory,
                url: url.replace('{{date}}', date)
                // .replace('{{frommonth}}', frommonth).replace('{{tomonth}}', tomonth)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: MONTH_END_INVENTORY_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: MONTH_END_INVENTORY_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

    }



export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: MONTH_END_INVENTORY_LOADING,
        isLoading
    })
}
